import React, { useContext } from 'react';
import { StoreContext } from '../../context/Store';
import { CategoryBar, CategoryTab } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CategoryFilter = _ref => {
  let {
    options
  } = _ref;
  const {
    categoryFilter,
    setCategoryFilter,
    setManufacturersFilter,
    setSubcategoriesFilter
  } = useContext(StoreContext);
  const onClickTab = value => {
    setCategoryFilter(value);
    setManufacturersFilter([]);
    setSubcategoriesFilter([]);
  };
  return ___EmotionJSX(CategoryBar, null, ___EmotionJSX(CategoryTab, {
    onClick: () => onClickTab(null),
    className: categoryFilter === null ? 'current' : null
  }, "Alle"), options.map(filter => ___EmotionJSX(CategoryTab, {
    key: filter.category_id.id,
    onClick: () => onClickTab(filter.category_id.id),
    className: categoryFilter === filter.category_id.id ? 'current' : null
  }, filter.category_id.display_name)));
};
export default CategoryFilter;